import { GET_TEXTURE } from "../constants";
import {
  getTextureSuccess,
  setLoaderComplete,
  setLoaderStart,
  getTextureError,
} from "../actions";
import { put, takeLatest, call } from "redux-saga/effects";
import { API_URL, BASE_URL } from "../axios/config";
import axios from "../axios";

async function getTextureApi(data) {
  return axios.request({
    method: "get",
    url: BASE_URL + API_URL.TEXTURE_URL,
    data: data,
  });
}

function* getTextureAction(action) {
  let { payload, resolve, reject } = action;
  try {
    yield put(setLoaderStart());
    let response = yield call(getTextureApi, payload);
    yield put(setLoaderComplete());
    if (response.status === 200) {
      console.log("response.data.data", response);
      yield put(getTextureSuccess(response));
      if (resolve) resolve(response);
    } else {
      yield put(getTextureError(response));
      if (reject) reject(response);
    }
  } catch (e) {
    console.log("error =======> ", e);
    yield put(setLoaderComplete());
    yield put(getTextureError(e));
    if (reject) reject(e);
  }
}

export function* getTextureWatcher() {
  yield takeLatest(GET_TEXTURE, getTextureAction);
}
